import React from 'react';

import styled from '@emotion/styled';

import ChartWrapper from '../../../components/Charts/ChartWrapper';
import PieChart from '../../../components/Charts/PieChart';

interface ChatItem {
  name: string;
  value: number;
  color: string;
  textColor: string;
}
interface DisputeResponseInsightsProps {
  incidentReports?: ChatItem[];
  hiringConflicts?: ChatItem[];
  conflictIssues?: ChatItem[];
}

const DisputeResponseInsights: React.FC<DisputeResponseInsightsProps> = ({
  incidentReports,
  hiringConflicts,
  conflictIssues,
}) => {
  return (
    <WrappedChartWrapper label='Dispute Response Insights'>
      <Container>
        <ChartWrapper
          label='Incident reports'
          // maxWidth='100%'
          className='borderless small-label'
        >
          <PieChart
            data={incidentReports}
            aspect={1.2}
            outerRadius={90}
            cy='44%'
            showLabels
            showPercentInLabel
            decimalPlaces={1}
            legendVerticalAlign='bottom'
            legendAlign='center'
            // legendLayout='horizontal'
            legendLayout='vertical'
            legendValueFormatter={(item) => item.legendValue ?? item.value}
            tooltipValueFormatter={(value) => `${value.toFixed(1)}%`}
          />
        </ChartWrapper>

        <ChartWrapper
          label='Hiring Conflicts'
          //  maxWidth='100%'
          className='borderless small-label'
        >
          <PieChart
            data={hiringConflicts}
            aspect={1.2}
            outerRadius={90}
            cy='44%'
            showLabels
            showPercentInLabel
            decimalPlaces={1}
            legendVerticalAlign='bottom'
            legendAlign='center'
            // legendLayout='horizontal'
            legendLayout='vertical'
            legendValueFormatter={(item) => item.legendValue ?? item.value}
            tooltipValueFormatter={(value) => `${value.toFixed(1)}%`}
          />
        </ChartWrapper>

        <ChartWrapper
          label='Conflict Issues'
          // maxWidth='100%'
          className='borderless small-label'
        >
          <PieChart
            data={conflictIssues}
            aspect={1.2}
            outerRadius={90}
            cy='44%'
            showLabels
            showPercentInLabel
            decimalPlaces={1}
            legendVerticalAlign='bottom'
            legendAlign='center'
            // legendLayout='horizontal'
            legendLayout='vertical'
            legendValueFormatter={(item) => item.legendValue ?? item.value}
            tooltipValueFormatter={(value) => `${value.toFixed(1)}%`}
          />
        </ChartWrapper>
      </Container>
    </WrappedChartWrapper>
  );
};

export default DisputeResponseInsights;

const WrappedChartWrapper = styled(ChartWrapper)`
  grid-column: span 3;
`;

const Container = styled.div`
  width: 100%;
  grid-column: span 3;
  display: flex;
  /* justify-content: space-between; */

  gap: 24px;
`;
